import { render } from "./treatment.vue?vue&type=template&id=02db9262&scoped=true"
import script from "./treatment.vue?vue&type=script&lang=js"
export * from "./treatment.vue?vue&type=script&lang=js"

import "./treatment.vue?vue&type=style&index=0&id=02db9262&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02db9262"]])

export default __exports__